import React, { useMemo } from 'react';

import { BuiltInComponents } from 'craft/constants';

import { Checklist } from './Checklist';
import { Flow } from './Flow';
import { Generic } from './Generic';

export const AllowedNodeAnalyticsComponents = [
  'CheckListGroup',
  BuiltInComponents.Flow,
  BuiltInComponents.Button,
  BuiltInComponents.Link,
  BuiltInComponents.Card,
  BuiltInComponents.Image,
];

const NodeAnalyticsComponent = {
  CheckListGroup: Checklist,
  [BuiltInComponents.Flow]: Flow,
  [BuiltInComponents.Button]: Generic,
  [BuiltInComponents.Link]: Generic,
  [BuiltInComponents.Card]: Generic,
  [BuiltInComponents.Image]: Generic,
};

interface Props {
  nodeType: string;
  documentNodeId: string;
  contentId: string;
}

export const NodeAnalytics = ({ documentNodeId, contentId, nodeType }: Props) => {
  const AnalyticsComponent = useMemo(() => {
    // @ts-ignore
    return NodeAnalyticsComponent[nodeType] || (() => null);
  }, [nodeType]);

  return (
    <AnalyticsComponent
      key={documentNodeId}
      contentId={contentId}
      documentNodeId={documentNodeId}
    />
  );
};
